import { MenuItem, Select } from '@material-ui/core';
import { Control, Controller, RegisterOptions } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import useGetLabel from '../../hooks/useGetLabel';
import { TransportationSelectionType } from '../../modules/generated/api';
import { TRANSPORTATION_SELECTION_TYPE_LABELS } from '../../modules/labels';

type PurchaseAgentTransportSelectProps = {
  control: Control<any>;
  name: string;
  disabled?: boolean;
  rules?: RegisterOptions;
};

const PurchaseAgentTransportSelect = ({ control, name, disabled, rules }: PurchaseAgentTransportSelectProps) => {
  const { t } = useTranslation();
  const getTransportLabel = useGetLabel(TRANSPORTATION_SELECTION_TYPE_LABELS);

  return (
    <Controller
      control={control}
      name={name}
      rules={rules}
      render={({ field }) => (
        <Select {...field} variant="standard" value={field.value || 'empty'} displayEmpty disabled={disabled}>
          <MenuItem value="empty" disabled>
            {t('purchaseAgent.form.transportProvider')}
          </MenuItem>
          {Object.values(TransportationSelectionType)
            .filter((v) => v !== TransportationSelectionType.Unknown)
            .map((value) => (
              <MenuItem key={value} value={value}>
                {getTransportLabel(value)}
              </MenuItem>
            ))}
        </Select>
      )}
    />
  );
};

export default PurchaseAgentTransportSelect;
